import styled from "styled-components";

export const GlobalCompanyDrawerCountersWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: flex-start;
  padding: 0px;
  flex-wrap: wrap;

  & > :not(:last-child) {
    margin-right: 20px;
  }
`;

export const GlobalCompanyDrawerCounterContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  & > :not(:last-child) {
    margin-bottom: 8px;
  }
`;

export const GlobalCompanyDrawerCounterIconContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  & > :not(:last-child) {
    margin-right: 8px;
  }
`;

export const GlobalCompanyDrawerCounter = styled.span`
  font-weight: 300;
  font-size: 38px;
  line-height: 42px;
  text-align: center;
  color: #171C33;
`

export const GlobalCompanyDrawerCounterText = styled.span`
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  text-align: center;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: rgba(23, 28, 51, 0.5);
`;

export const GlobalCompanyDrawerHighlightText = styled.h4`
  font-weight: 300;
  font-size: 24px;
  line-height: 31px;

  & .people {
    color: #FFC229;
  }

  & .company {
    color: #5478A1;
  }

  & .skill {
    color: #EB823D;
  }
`;

export const GlobalCompanyDrawerHighlightTextContainer = styled.div`
  & :not(:last-child) {
    margin-bottom: 10px;
  }
`;

export const GlobalCompanyDrawerBioText = styled.p`
  font-weight: 400;
  font-size: 18px;
  line-height: 23px;
  color: var(--color-text);

  margin-bottom: 48px !important;
`;